<button mat-button [type]="inputType" [disabled]="isDisabled" [ngClass]="buttonClass">{{ buttonText }}</button>